import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
    SIGNUP_USER,
    SIGNIN_USER,
    OTP_USER,
    SIGNOUT_USER,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
} from '../actions';

import {
    signupUserSuccess,
    signupUserError,
    signinUserSuccess,
    signinUserError,
    otpUserSuccess,
    otpUserError,
    forgotPasswordSuccess,
    forgotPasswordError,
    resetPasswordSuccess,
    resetPasswordError
} from './actions';

import {
    baseURL
} from "../../constants/defaultValues";

/* Signup Flow */
export function* watchSignupUser() {
    yield takeEvery(SIGNUP_USER, signupWithPhonenumber);
}

function* signupWithPhonenumber({ payload }) {
    const { phoneNumber,displayName,gender,birthYear } = payload.user;
    const { history } = payload;

    // Prepare API Request Data
    const password = "ios1234";
    const data = {
        phoneNumber,
        displayName,
        gender,
        birthYear,
        password
    };

    let response;
    try {
        response = yield axios.post(`${baseURL}/users/signup`,data);
        if (response && response.data && response.data.token) {
            localStorage.setItem('user_id', response.data._id);
            localStorage.setItem('user_name', response.data.displayName);
            // Assign Phone Number
            localStorage.setItem('user_phone', phoneNumber);
            response.data.phoneNumber = phoneNumber;
            // Generate Token
            yield axios.post(`${baseURL}/users/token`,{phoneNumber,password});
            yield put(signupUserSuccess(response.data));
            history.push('/user/otp');
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Signing up, Please verify data";
            yield put(signupUserError(message));
        }

    } catch (error) {
        // Error
        const message = response && response.data && response.data.message ? response.data.message :
        "Error Signining In, Please verify data";
        yield put(signupUserError(message));
    }
}

/* Signin Flow */
export function* watchSigninUser() {
    yield takeEvery(SIGNIN_USER, signinWithPhonenumber);
}

function* signinWithPhonenumber({ payload }) {
    const { phoneNumber } = payload.user;
    const { history } = payload;

    // Prepare API Request Data
    // Prepare API Request Data
    const password = "ios1234";
    const data = {
        phoneNumber,
        displayName:"User",
        gender:"Male",
        birthYear:1980,
        password
    };
    
    let response;
    try {
        // Generate Token
        response = yield axios.post(`${baseURL}/users/signin`,data);
        if (response && response.data && response.data._id) {
            // Assign Phone Number
            localStorage.setItem('user_phone', phoneNumber);
            response.data.phoneNumber = phoneNumber;
            yield put(signinUserSuccess(response.data));
            history.push('/user/otp');
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Signining In, Please verify data";
            yield put(signinUserError(message));
        }
    } catch (error) {
        // Error
        const message = response && response.data && response.data.message ? response.data.message :
        "Error Signining In, Please verify data";
        yield put(signinUserError(message));
    }
}

/* OTP Flow */
export function* watchOTPUser() {
    yield takeEvery(OTP_USER, signinWithOTP);
}

function* signinWithOTP({ payload }) {
    const { phoneNumber, token } = payload.user;
    const { history } = payload;

    // Prepare API Request Data
    const password = "ios1234";
    const data = {
        phoneNumber,
        token,
        password
    };

    let response;
    try {
        response = yield axios.post(`${baseURL}/users/login`,data);
        if (response && response.data && response.data.token) {
            localStorage.setItem('user_id', response.data._id);
            localStorage.setItem('user_token', response.data.token);
            localStorage.setItem('user_name', response.data.displayName);
            // Assign Phone Number
            localStorage.setItem('user_phone', phoneNumber);
            response.data.phoneNumber = phoneNumber;
            yield put(otpUserSuccess(response.data));
            history.push('/');
        } else {
            // Error
            const message = response && response.data && response.data.message ? response.data.message :
            "Error Signining In, Please verify data";
            yield put(otpUserError(message));
        }
    } catch (error) {
        // Error
        const message = response && response.data && response.data.message ? response.data.message :
        "Error Signining In, Please verify data";
        yield put(otpUserError(message));
    }
}

/* Signout Flow */
export function* watchSignoutUser() {
    yield takeEvery(SIGNOUT_USER, signout);
}

const signoutAsync = async (history) => {
    history.push('/')
}

function* signout({ payload }) {
    const { history } = payload
    try {
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_token');
        localStorage.removeItem('user_name');
        localStorage.removeItem('user_phone');
        yield call(signoutAsync, history);
    } catch (error) {

    }
}

export function* watchForgotPassword() {
    yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

function* forgotPassword({ payload }) {
    const { email } = payload.forgotUserMail;
    try {
        const forgotPasswordStatus = yield call('forgotPasswordAsync', email);
        if (!forgotPasswordStatus) {
            yield put(forgotPasswordSuccess("success"));
        } else {
            yield put(forgotPasswordError(forgotPasswordStatus.message));
        }
    } catch (error) {
        yield put(forgotPasswordError(error));

    }
}

export function* watchResetPassword() {
    yield takeEvery(RESET_PASSWORD, resetPassword);
}

function* resetPassword({ payload }) {
    const { newPassword, resetPasswordCode } = payload;
    try {
        const resetPasswordStatus = yield call('resetPasswordAsync', resetPasswordCode, newPassword);
        if (!resetPasswordStatus) {
            yield put(resetPasswordSuccess("success"));
        } else {
            yield put(resetPasswordError(resetPasswordStatus.message));
        }
    } catch (error) {
        yield put(resetPasswordError(error));

    }
}

export default function* rootSaga() {
    yield all([
        fork(watchSignupUser),
        fork(watchSigninUser),
        fork(watchOTPUser),
        fork(watchSignoutUser),
        fork(watchForgotPassword),
        fork(watchResetPassword),
    ]);
}